// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__wUFZr","light_button":"button_light_button__205eS"};